module.exports = __webpack_public_path__ + "static/media/ToothBone.a3bde9d7.jpeg";